import { PublicClientApplication } from "@azure/msal-browser";

import { getEnv } from "./env";

export const msalConfig = {
  auth: {
    clientId: getEnv("REACT_APP_CLIENT_ID"),
    authority: `https://login.microsoftonline.com/${getEnv("REACT_APP_TENANT_ID")}`,
    redirectUri: getEnv("REACT_APP_REDIRECT_URI"),
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
